<template>
  <v-dialog v-model="openDialog" width="1000px" height="450" persistent scrollable>
    <template v-slot:activator="{ on }">
      <div :class="buttonCSSClass">
        <mf-button class="mt-n2" text :disabled="disabled" label="Importar mensagens" color="marca-0-l40" v-on:click.native="on.click" />
      </div>
    </template>
    <v-card class="card-padding">
      <v-card-title class="px-0 pt-3 pb-0">
        <h3 class="px-0 section-title">Mensagens</h3>
        <p class="mb-0 px-0 texto-corrido text-size">
          Para facilitar a criação da sua campanha, temos algumas ideias de mensagens pra te oferecer. Também é possível utilizar mensagens de campanhas
          existentes.
        </p>
      </v-card-title>
      <v-card-text class="px-0 pb-0 mt-n3">
        <mf-tabs-menu v-model="templateTab" class="mt-4" :tabs="tabsMenuItems" />
        <template-message-list
          v-show="templateTab === 0"
          v-model="loadingMessage"
          :templateMessageArray="templateMessageArray"
          :getListTemplateMessage="loadMoreTemplate"
          :filteredTags.sync="filteredTags"
          :search.sync="messagesVariables.search"
          @add-new-template="addNewTemplate"
        />
        <template-message-campaigns v-show="templateTab === 1" v-model="campaigns" :mode="mode" />
        <template-message-empty v-if="isEmpty" />
        <mf-action-buttons
          class="py-3"
          :primary-button="{
            text: templateTab === 1 ? 'Selecionar' : 'Fechar',
            action: templateTab === 1 ? selectCampaign : closeDialog,
            isVisible: true,
          }"
          :extra-button="{
            text: 'Fechar',
            action: closeDialog,
            isVisible: templateTab === 1,
          }"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import TemplateMessageList from './TemplateMessageList.vue'
import TemplateMessageEmpty from './TemplateMessageEmpty.vue'
import TemplateMessageCampaigns from './TemplateMessageCampaigns.vue'
import { QUERY_LIST_TEMPLATE_MESSAGE } from './graphql'
import { cloneDeep } from 'lodash'

const defaultVariables = {
  page: 1,
  pageSize: 15,
  search: '',
  sort: ['quantity_used'],
  sortDirection: ['DESC'],
}

export default {
  name: 'TemplateMessageModal',
  components: {
    TemplateMessageCampaigns,
    TemplateMessageList,
    TemplateMessageEmpty,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      required: true,
    },
    mode: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    loadingMessage: false,
    openDialog: false,
    timeout: null,
    templateTab: 0,
    records: 0,
    messagesVariables: {},
    campaigns: [],
    filteredTags: [],
    templateMessageArray: [],
  }),
  computed: {
    selectedMessage: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    tabsMenuItems() {
      return [
        {
          name: 'Templates prontos',
          offerSalesKeyName: 'templates',
        },
        {
          name: 'Últimas campanhas',
          offerSalesKeyName: 'campaigns',
        },
      ]
    },
    isEmpty() {
      if (this.templateTab === 0 && !this.templateMessageArray.length && !this.loadingMessage) {
        return true
      }
      return false
    },
    tagsId() {
      return this.filteredTags.map((tag) => tag._id)
    },

    buttonCSSClass() {
      return this.disabled ? 'disabled-button-import' : 'button-import'
    },
  },
  watch: {
    openDialog() {
      if (this.openDialog) this.getListTemplateMessage()
    },
    tagsId() {
      if (this.openDialog) this.newTemplateSearch()
    },
    'messagesVariables.search': function searchInput() {
      if (this.openDialog) this.newInputSearch()
    },
  },
  mounted() {
    this.messagesVariables = cloneDeep(defaultVariables)
  },
  methods: {
    closeDialog() {
      this.templateMessageArray = []
      this.filteredTags = []
      this.records = 0
      this.messagesVariables = cloneDeep(defaultVariables)
      this.openDialog = false
    },
    addNewTemplate(message) {
      this.openDialog = false
      this.selectedMessage = message
    },
    getListTemplateMessage() {
      this.loadingMessage = true

      const variables = cloneDeep(this.messagesVariables)
      variables.channels = this.mode

      if (this.tagsId.length) {
        variables.tags = this.tagsId
      }

      this.$apollo
        .query({
          query: QUERY_LIST_TEMPLATE_MESSAGE,
          variables,
        })
        .then(
          ({
            data: {
              messageTemplates: { page, records, templates },
            },
          }) => {
            this.templateMessageArray.push(...templates)
            this.messagesVariables.page = page
            this.records = records
            this.loadingMessage = false
          }
        )
    },
    loadMoreTemplate() {
      if (this.templateMessageArray.length >= this.records) return

      this.messagesVariables.page += 1
      this.getListTemplateMessage()
    },
    newTemplateSearch() {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.messagesVariables.page = 1
        this.messagesVariables.pageSize = 15
        this.templateMessageArray = []

        this.getListTemplateMessage()
      }, 500)
    },
    newInputSearch() {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.newTemplateSearch()
      }, 1000)
    },
    selectCampaign() {
      const [
        {
          message: { text },
        },
      ] = this.campaigns

      this.selectedMessage = { message: text, _id: '' }
      this.closeDialog()
    },
  },
}
</script>

<style lang="scss">
.button-import {
  .theme--light.v-btn {
    color: $marca-0-l40 !important;
  }
  .v-btn.v-size--default {
    font-size: 14px !important;
  }
}

.disabled-button-import {
  .theme--light.v-btn {
    color: rgba(0, 0, 0, 0.26) !important;
  }
  .v-btn.v-size--default {
    font-size: 14px !important;
  }
}

.card-padding {
  padding: 0 36px;
}
.text-size {
  font-size: 16px !important;
}
</style>
